// extracted by mini-css-extract-plugin
export default {"container":"DownSdk_container__SkukU","downSdkText":"DownSdk_downSdkText__1TtTs","downSdkBtn":"DownSdk_downSdkBtn__2pesr","linkText":"DownSdk_linkText__JCSh7"};